export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 pt-16"
    >
      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex flex-wrap items-center gap-2 justify-center lg:justify-start mb-4">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                免费全集
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
                离线阅读
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                日漫韩漫国漫
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-3">
              樱花漫画 - 你的随身漫画图书馆
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-heading mb-6">
              收藏追更，随时随地畅读万部漫画
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              樱花漫画汇聚海量日漫、韩漫、国漫资源，支持高清漫画下载与离线阅读，让你在没有网络时也能尽情享受精彩故事。
              每日同步更新最新连载，智能追更提醒不错过任何一话，个性化收藏夹帮你整理所有心爱作品。
              无论你是热血少年漫爱好者，还是偏爱恋爱甜宠、悬疑推理、古风仙侠，这里都有属于你的漫画世界。
            </p>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>每日同步更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>海量正版内容</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>极速离线下载</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#carousel');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#app');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-200 transition-colors border border-background-200/70 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20stylized%20digital%20illustration%20of%20a%20person%20reading%20manga%20on%20a%20tablet%20in%20a%20cozy%20minimal%20room%20with%20warm%20lighting%2C%20floating%20colorful%20comic%20panels%20and%20speech%20bubbles%20in%20the%20background%2C%20soft%20coral%20and%20amber%20color%20palette%2C%20artistic%20watercolor%20texture%2C%20editorial%20composition%2C%20modern%20manga%20reading%20experience%2C%20peaceful%20atmosphere%20with%20dynamic%20comic%20elements%2C%20warm%20cream%20background%20with%20subtle%20gradient&width=700&height=525&seq=sakura-hero-01&orientation=landscape"
                alt="樱花漫画 - 随时随地在平板上阅读漫画，温馨舒适的场景"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}